import Alese from '../images/logos/logosRelifClients/Alese.webp';
import Astara from '../images/logos/logosRelifClients/Astara.png';
import AutoCl from '../images/logos/logosRelifClients/AutoCl.png';
import Carmona from '../images/logos/logosRelifClients/Carmona.png';
import CertifyCar from '../images/logos/logosRelifClients/CertifyCar.png';
import DanielAchondo from '../images/logos/logosRelifClients/DanielAchondo.png';
import Dumay from '../images/logos/logosRelifClients/Dumay.png';
import JPN from '../images/logos/logosRelifClients/JPN.png';
import PompeyoCarrasco from '../images/logos/logosRelifClients/PompeyoCarrasco.png';
import Rosselot from '../images/logos/logosRelifClients/Rosselot.png';
import Salfa from '../images/logos/logosRelifClients/Salfa.png';
import SalfaSur from '../images/logos/logosRelifClients/SalfaSur.png';

const carDealerships = [
  Alese,
  Astara,
  AutoCl,
  Carmona,
  CertifyCar,
  DanielAchondo,
  Dumay,
  JPN,
  PompeyoCarrasco,
  Rosselot,
  Salfa,
  SalfaSur,
];

export default carDealerships;
